export default "__VITE_ASSET__bf0bddf9__$_?component__"